import React from 'react';
import styled from 'styled-components';

import MenuItem from '@mui/material/MenuItem';
import CheckIcon from '@mui/icons-material/Check';

import SearchIcon from '@mui/icons-material/Search';

import { CircularProgress } from '@mui/material';

import { colors } from 'theme/colors';

import { RichTextInput } from 'ui/TextInput';

export const StyledMenuItem = styled(MenuItem)`
  font-size: 1.4rem;
  padding: 8px 12px;
  justify-content: space-between;
`;

export const StyledCheckIcon = styled(CheckIcon)`
  font-size: 16px;
  margin-left: 8px;
`;

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 8px 16px;
  align-items: center;
`;

export const StyledTextInput = styled(RichTextInput)`
  > p {
    border: none;
    font: normal normal normal 14px/16px Roboto;
    margin: 4px;
    margin-left: 8px;
    padding: 0;
    height: 16px;
  }
  min-width: 205px;
`;

export const StyledSearchIcon = styled(SearchIcon)`
  width: 16px;
  color: ${colors.ui.chip.grayText};
`;

export const Separator = styled.hr`
  border: none;
  height: 1px;
  background-color: ${colors.ui.border.main};
  margin: 0;
`;

export const StyledCircularProgress = styled(CircularProgress)`
  padding: 1rem;
  margin: 0 auto;
`;

export const ListContent = styled.div<{
  customMargin?: {
    marginLeft: string;
    marginRight: string;
  };
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  margin-left: ${(props) => (props.customMargin ? props.customMargin.marginLeft : '16px')};
  margin-right: ${(props) => (props.customMargin ? props.customMargin.marginLeft : '0px')};
`;
